<template>
    <v-container>
        <HeadbarPage :title="'Títulos > Cessão de Títulos'"></HeadbarPage>
        <v-card class="mt-2 mb-3">
            <v-row class="mx-6 mt-3 pt-3">
                <v-col>
                    <span
                        class="text-left font-weight-black display-1 pl-0"
                        :style="{ color: primaryColorFont }"
                        >Cessão de Títulos</span
                    >
                </v-col>
            </v-row>
            <v-row class="mx-6">
                <v-col cols="12" sm="12" md="12">
                    <div class="ghost-card">
                        <div class="mb-5">
                            <span class="title">Filtros de Cessão</span>
                        </div>

                        <v-row class="mb-3">
                            <v-col cols="12" sm="12" md="6">
                                <v-select
                                    outlined
                                    dense
                                    :items="apresentantes"
                                    v-model="filtros.apresentanteOrigem"
                                    label="Apresentante Origem"
                                    item-text="cd_apresentante"
                                    item-value="cd_apresentante"
                                    :rules="[v => !!v || 'Apresentante Origem é obrigatório']"
                                    required
                                />
                            </v-col>
                        </v-row>

                        <v-textarea
                            solo
                            small
                            label="Inserir Títulos (ds_nosso_numero ou id_titulo) *"
                            hint="Insira os códigos dos títulos (ds_nosso_numero ou id_titulo) separados por vírgulas, exemplo: 477977/1, 721603/6, 755202/5, 55555, 44444, 222222"
                            placeholder="Cole aqui os títulos que deseja transferir"
                            v-model="filtros.ds_nosso_numero"
                            :rules="[v => !!v || 'Campo obrigatório']"
                            required
                        >
                            <template v-slot:append>
                                <v-icon
                                    @click="limparCampo"
                                    class="v-icon--clearable"
                                >
                                    mdi-close
                                </v-icon>
                            </template>
                        </v-textarea>
                        <v-row style="width: 50%;">
                            <v-col cols="12" sm="12" md="12">
                                <div class="mb-5">
                                    <span class="title">Upload de Arquivo</span>
                                </div>
                                <div class="d-flex">
                                    <v-file-input
                                        prepend-icon=""
                                        class="mb-n7 mr-2 white--text"
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xls, .xlsx, .xlsm"
                                        label="Escolher arquivo "
                                        show-size
                                        chips
                                        dense
                                        v-model="file"
                                        solo
                                        ref="myFileInput"
                                        id="fileInput"
                                        name="file"
                                        @change="uploadFileReference"
                                        :key="counterRender"
                                    ></v-file-input>
                                    <v-btn
                                        @click="openUpload()"
                                        class="text-capitalize mr-2"
                                    >
                                        <v-icon class="ma-2 text-left">
                                            mdi-upload
                                        </v-icon>
                                        upload
                                    </v-btn>
                                    <v-btn
                                        class="text-capitalize"
                                        :href="link_modelo"
                                    >
                                        <v-icon class="ma-2 text-left">
                                            mdi-download
                                        </v-icon>
                                        Baixar Modelo
                                    </v-btn>
                                </div>
                                <div class="my-5">
                                    <span class="sub-title">
                                        Formatos compatíveis: .xls/.xlsx/.xlsm.
                                        Limite de tamanho: 60mb
                                    </span>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row class="mt-5">
                            <v-col
                                cols="12"
                                sm="6"
                                class="d-flex justify-start"
                            >
                                <v-btn
                                    color="grey lighten-1"
                                    class="white--text"
                                    @click="limparFiltros"
                                >
                                    Limpar Filtros
                                    <v-icon class="ml-2">mdi-broom</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" class="d-flex justify-end">
                                <v-btn
                                    color="primary"
                                    :loading="loadingFiltros"
                                    :disabled="!filtrosValidos"
                                    @click="botaoFiltrar"
                                >
                                    Filtrar
                                    <v-icon class="ml-2">mdi-magnify</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
        </v-card>

        <TableWithSelections
            ref="tableWithSelections"
            :titulos="titulos"
            :totalTitulos="totalTitulos"
            :loading="loading"
            :headers="headers"
            @selecionados="setSelecionados"
            @changeOptionsPage="changeOptionsPage"
            @selecionarTodos="setTodosSelecionados"
        />

        <v-row class="ma-0">
            <v-spacer></v-spacer>
            <v-col sm="6" md="3" lg="4" class="d-flex justify-end pr-0">
                <v-tooltip top :disabled="selecionados.length !== 0">
                    <template v-slot:activator="{ on }">
                        <div v-on="on">
                            <v-btn
                                class="d-flex justify-center"
                                color="green white--text"
                                @click="abrirModalCessao"
                                :disabled="!selecionados.length"
                                v-intersect="onIntersect"
                            >
                                Cessão de Títulos
                                <v-icon class="ml-2"
                                    >mdi-swap-horizontal-bold</v-icon
                                >
                            </v-btn>
                        </div>
                    </template>
                    <span
                        >Selecione um ou mais títulos para realizar a
                        cessão</span
                    >
                </v-tooltip>
            </v-col>
        </v-row>

        <v-btn
            v-show="mostrarBotaoFlutuante"
            color="green"
            dark
            fab
            fixed
            right
            bottom
            class="botao-flutuante"
            @click="abrirModalCessao"
            :disabled="!selecionados.length"
        >
            <v-icon>mdi-swap-horizontal-bold</v-icon>
        </v-btn>

        <v-dialog
            v-model="showModal"
            max-width="900px"
            persistent
            scrollable
            color="background"
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="fecharModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>

                    <v-toolbar-title>
                        Confirmação de Cessão de Títulos
                    </v-toolbar-title>
                </v-toolbar>
                <v-divider></v-divider>

                <v-card-text min-height="200px" style="border-radius: 0">
                    <v-list shaped>
                        <v-row class="mb-3">
                            <v-col cols="12" sm="6">
                                <v-card outlined>
                                    <v-card-title class="subtitle-1">
                                        <v-icon color="primary" class="mr-2"
                                            >mdi-arrow-up-bold-circle-outline</v-icon
                                        >
                                        Apresentante Origem
                                    </v-card-title>
                                    <v-card-text style="min-height: 80px">
                                        {{
                                            getApresentanteNome(
                                                filtros.apresentanteOrigem
                                            )
                                        }}
                                        -
                                        {{ filtros.apresentanteOrigem }}
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-card outlined>
                                    <v-card-title class="subtitle-1">
                                        <v-icon color="green" class="mr-2"
                                            >mdi-arrow-down-bold-circle-outline</v-icon
                                        >
                                        Apresentante Destino
                                    </v-card-title>
                                    <v-card-text style="min-height: 80px">
                                        <v-select
                                            outlined
                                            dense
                                            :items="apresentantes"
                                            v-model="
                                                filtros.apresentanteDestino
                                            "
                                            label="Selecione o Apresentante Destino"
                                            item-text="cd_apresentante"
                                            item-value="cd_apresentante"
                                            :rules="[
                                                v =>
                                                    !!v ||
                                                    'Apresentante Destino é obrigatório'
                                            ]"
                                            required
                                        />
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>

                        <v-subheader
                            class="primary--text title font-weight-black"
                        >
                            Títulos selecionados:
                            {{ titulosSelecionados.length }}
                        </v-subheader>

                        <v-data-table
                            :headers="activeHeadersModal"
                            :items="titulosSelecionados"
                            class="elevation-1 mb-4"
                            disable-sort
                            :items-per-page="10"
                        >
                            <template
                                v-if="tituloSearch"
                                v-slot:[`item.comentario`]="{ item }"
                            >
                                <v-text-field
                                    v-model="item.comentario"
                                    dense
                                    outlined
                                    hide-details
                                    single-line
                                    placeholder="Adicionar comentário"
                                    maxlength="2000"
                                    counter="2000"
                                ></v-text-field>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon
                                    small
                                    color="error"
                                    @click="removerTitulo(item)"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                        </v-data-table>

                        <v-subheader
                            v-if="!tituloSearch || !Array.isArray(tituloSearch)"
                            class="primary--text title font-weight-black"
                        >
                            Observação da Cessão
                        </v-subheader>

                        <v-textarea
                            v-if="
                                (!tituloSearch ||
                                    !Array.isArray(tituloSearch)) &&
                                    titulosSelecionados.length > 0
                            "
                            outlined
                            label="Insira uma observação para esta cessão"
                            v-model="comentarioCessao"
                            rows="3"
                            maxlength="2000"
                            counter="2000"
                        ></v-textarea>
                        <v-text-field
                            style="width: 25%;"
                            v-model="filtros.cd_carteira"
                            maxlength="20"
                            dense
                            outlined
                            hide-details
                            single-line
                            placeholder="Código da Carteira"
                        ></v-text-field>
                    </v-list>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn
                        class="ma-2"
                        @click="fecharModal"
                        :disabled="loadingCessao"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        class="ma-2"
                        color="success"
                        @click="confirmarCessao"
                        :loading="loadingCessao"
                        :disabled="
                            titulosSelecionados.length === 0 ||
                                !filtros.apresentanteDestino
                        "
                    >
                        <v-icon class="mr-2">mdi-check-circle</v-icon>
                        Confirmar Cessão de Títulos
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <Snackbar
            v-if="snackbar"
            :mostrarSnackbar="snackbar"
            :corSnackbar="colorSnackbar"
            :mensagemSnackbar="mensagemSnackbar"
            @fecharSnackbar="snackbar = false"
        />

        <v-dialog
            v-model="dialogError"
            max-width="800px"
            persistent
            scrollable
            color="background"
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar flat dark color="error">
                    <v-btn icon dark @click="dialogError = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Erro</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-card-text class="font-weight-black">
                                <v-icon class="ma-1">mdi-alert</v-icon>
                                Erro ao enviar a arquivo de upload
                            </v-card-text>
                            <v-card-text>
                                Houve um erro ao ler o arquivo de upload. Por
                                favor, tente novamente.
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-end">
                    <v-btn
                        class="ma-2"
                        color="error"
                        @click="dialogError = false"
                    >
                        <v-icon>mdi-close</v-icon>Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import TituloService from '@/services/TituloService';
import ApresentanteService from '@/services/apresentanteService';
import Vue from 'vue';
import { listarAgrupadores } from '@/helpers/Utilitarios';
import XLSX from 'xlsx';

export default {
    name: 'CessaoTitulosV2',
    components: {
        HeadbarPage: () => import('@/components/atoms/HeadbarPage'),
        TableWithSelections: () =>
            import('@/components/atoms/TableWithSelectionsCessao'),
        Snackbar: () => import('@/components/Snackbar')
    },
    data() {
        return {
            counterRender: 1,
            file: null,
            dialogError: false,
            fileSearch: [],
            tituloSearch: null,
            showModal: false,
            snackbar: false,
            colorSnackbar: '',
            mensagemSnackbar: '',
            link_modelo: '/Planilha-atualizacao-em-massa-cessao.xlsx',
            filtros: {
                apresentanteOrigem: null,
                apresentanteDestino: null,
                ds_nosso_numero: null,
                cd_carteira: null
            },
            comentarioCessao: '', // Added for single comment
            tituloService: new TituloService(Vue.http, this.$store),
            apresentanteService: new ApresentanteService(Vue.http, this.$store),
            options: {
                page: 1,
                itemsPerPage: 300
            },
            apresentantes: [],
            titulos: [],
            todosTitulos: [],
            titulosSelecionados: [],
            totalTitulos: 0,
            loading: false,
            loadingFiltros: false,
            loadingCessao: false,
            selecionados: [],
            selecionarTodos: false,
            primaryColorFont: '#757575',
            headers: [
                {
                    text: 'Código do título',
                    sortable: true,
                    value: 'ds_nosso_numero'
                },
                {
                    text: 'Id do título',
                    sortable: true,
                    value: 'id_titulo'
                },
                {
                    text: 'Data de envio',
                    align: 'left',
                    sortable: true,
                    value: 'dt_cadastro'
                },
                {
                    text: 'CPF/CNPJ',
                    sortable: true,
                    value: 'nu_identificacao_devedor'
                },
                { text: 'Nome', sortable: true, value: 'nm_devedor' },
                {
                    text: 'Valor R$',
                    sortable: true,
                    value: 'vl_saldo_protesto'
                },
                { text: 'Status', sortable: true, value: 'cd_status' },
                {
                    text: 'Data de atualização',
                    align: 'left',
                    sortable: true,
                    value: 'dt_atualizacao'
                },
                { text: 'Original', sortable: true, value: 'fl_original' },
                { text: ' ', sortable: true, value: 'action' }
            ],
            headersModal: [
                { text: 'Nosso número', value: 'ds_nosso_numero' },
                { text: 'ID do título', value: 'id_titulo' },
                { text: 'Comentário', value: 'comentario' },
                {
                    text: 'Ações',
                    value: 'actions',
                    sortable: false,
                    width: '100px'
                }
            ],
            mostrarBotaoFlutuante: false
        };
    },
    computed: {
        filtrosValidos() {
            return (
                this.filtros.apresentanteOrigem &&
                this.filtros.ds_nosso_numero
            );
        },
        activeHeadersModal() {
            if (!this.tituloSearch) {
                return this.headersModal.filter(
                    header => header.value !== 'comentario'
                );
            }
            return this.headersModal;
        }
    },
    async mounted() {
        await this.carregarApresentantes();
        if (this.$store.getters.isPartner == 1) {
            this.primaryColorFont = '#757575';
        } else {
            this.primaryColorFont = this.$vuetify.theme.themes.light.primary;
        }

        this.titulos = [];
        this.totalTitulos = 0;
    },
    methods: {
        listarAgrupadores,
        onIntersect(entries) {
            const isIntersecting = entries[0].isIntersecting;
            this.mostrarBotaoFlutuante = !isIntersecting;
        },
        async carregarApresentantes() {
            this.loading = true;
            return new Promise((resolve, reject) => {
                try {
                    this.apresentanteService.listarApresentantes().then(
                        response => {
                            if (response.status == 200) {
                                let arr_apresentantes = [...response.body];

                                arr_apresentantes.sort((a, b) => {
                                    let nomeA = a.nm_apresentante.toUpperCase();
                                    let nomeB = b.nm_apresentante.toUpperCase();
                                    if (nomeA < nomeB) {
                                        return -1;
                                    }
                                    if (nomeA > nomeB) {
                                        return 1;
                                    }
                                    return 0; // nomes iguais
                                });

                                this.apresentantes = arr_apresentantes;
                            }
                            this.loading = false;
                            resolve();
                        },
                        error => {
                            console.log(error);
                            this.mostrarSnackbar(
                                'error',
                                'Erro ao carregar apresentantes'
                            );
                            this.loading = false;
                            reject(error);
                        }
                    );
                } catch (e) {
                    this.mensagem = e;
                    console.log(e);
                    this.loading = false;
                    reject(e);
                }
            });
        },
        limparCampo() {
            this.filtros.ds_nosso_numero = null;
        },
        limparFiltros() {
            this.filtros = {
                apresentanteOrigem: null,
                apresentanteDestino: null,
                ds_nosso_numero: null
            };
            this.titulos = [];
            this.totalTitulos = 0;
            this.selecionados = [];
            if (this.$refs.tableWithSelections) {
                this.$refs.tableWithSelections.resetSelecionados();
            }
        },
        getApresentanteNome(cdApresentante) {
            if (!cdApresentante) return '';
            const apresentante = this.apresentantes.find(
                a => a.cd_apresentante === cdApresentante
            );
            return apresentante ? apresentante.nm_apresentante : '';
        },
        botaoFiltrar() {
            if (!this.filtrosValidos) {
                this.mostrarSnackbar(
                    'warning',
                    'Informe o ID do título ou preencha ambos os campos de Apresentante'
                );
                return;
            }
            this.buscarTitulos(this.filtros, true);
        },
        formatarDocumento() {
            var nu_identificacao_devedor = this.filtros
                .nu_identificacao_devedor;
            if (nu_identificacao_devedor != null) {
                nu_identificacao_devedor = nu_identificacao_devedor.match(
                    /\d/g
                );
                nu_identificacao_devedor = nu_identificacao_devedor.join('');
                return nu_identificacao_devedor;
            } else {
                return null;
            }
        },
        openUpload() {
            this.$refs.myFileInput.$el.querySelector('input').click();
        },
        uploadFileReference(e) {
            if (!e) {
                this.uploadOk = false;
                this.dadosXls = null;
                this.customerCountRead++;
                this.fazendoUpload = false;
                return;
            }
            this.file = e;
            this.uploadOk = false;
            const reader = new FileReader();
            var vm = this;
            reader.onload = function(e) {
                var data = e.target.result;
                if (!data) {
                    vm.dialogError = true;
                    vm.counterRender = vm.counterRender++;
                    vm.$refs.myFileInput.reset();
                    return;
                }
                var workbook;
                try {
                    workbook = XLSX.read(data, { type: 'binary' });
                } catch (err) {
                    vm.dialogError = true;
                    vm.counterRender = vm.counterRender++;
                    vm.$refs.myFileInput.reset();
                    return;
                }
                let sheetName = workbook.SheetNames[0];
                let worksheet = workbook.Sheets[sheetName];
                let rowObject = XLSX.utils.sheet_to_row_object_array(worksheet);
                const finalJsonData = JSON.stringify(rowObject, undefined, 4);
                let rows = JSON.parse(finalJsonData);
                vm.customerCountRead = rows.length;
                vm.dadosXls = rows.map(e => e.ds_nosso_numero);

                let numeros = [];
                let ids = [];

                vm.tituloSearch = [];

                rows.forEach(e => {
                    const nossoNumero = e.ds_nosso_numero
                        ? String(e.ds_nosso_numero).trim()
                        : null;
                    const idTitulo = e.id_titulo
                        ? String(e.id_titulo).trim()
                        : null;
                    const comentario = e.comentario
                        ? String(e.comentario).trim()
                        : '';

                    if ((nossoNumero || idTitulo) && comentario) {
                        vm.tituloSearch.push({
                            ds_nosso_numero: nossoNumero,
                            id_titulo: idTitulo,
                            comentario: comentario
                        });
                    }

                    if (nossoNumero) numeros.push(nossoNumero);
                    if (idTitulo) ids.push(idTitulo);
                });

                let novosTitulos = [];
                if (numeros.length) novosTitulos.push(numeros.join(','));
                if (ids.length) novosTitulos.push(ids.join(','));

                let titulosStr = novosTitulos.join(',');

                const baseLista = vm.filtros.ds_nosso_numero
                    ? String(vm.filtros.ds_nosso_numero)
                    : '';
                const combinada = baseLista
                    ? baseLista + ',' + titulosStr
                    : titulosStr;
                const unicos = [
                    ...new Set(
                        combinada
                            .split(/[,;\s]+/)
                            .map(s => s.trim())
                            .filter(Boolean)
                    )
                ];
                vm.filtros.ds_nosso_numero = unicos.join(',');
            };
            reader.readAsBinaryString(this.file);
            this.fazendoUpload = true;
        },
        buscarTitulos(filtros, resetOptions = false) {
            if (!filtros || Object.values(filtros).every(val => val === null)) {
                this.loading = false;
                this.loadingFiltros = false;
                return Promise.resolve();
            }

            this.filtros = filtros;
            this.loading = true;

            if (resetOptions) {
                this.options.page = 1;
                this.options.itemsPerPage = 300;

                if (this.$refs.tableWithSelections) {
                    this.$refs.tableWithSelections.resetSelecionados();
                }
                this.selecionados = [];
            }

            let page = this.options.page;
            let itemsPerPage = this.options.itemsPerPage;

            let use_filtros = JSON.parse(JSON.stringify(this.filtros));
            use_filtros.id_titulo = '';
            use_filtros.cd_apresentante = use_filtros.apresentanteOrigem;
            use_filtros.cd_apresentante_destino =
                use_filtros.apresentanteDestino;

            if (this.selecionarTodos) {
                itemsPerPage = this.totalTitulos;
                use_filtros['linhas_full'] = 1;
                this.todosTitulos = [];
            }

            use_filtros = {
                ...use_filtros,
                ...use_filtros.filtros
            };

            if (use_filtros.ds_nosso_numero) {
                if (!String(use_filtros.ds_nosso_numero).includes('/')) {
                    use_filtros = {
                        ...use_filtros,
                        id_titulo: use_filtros.ds_nosso_numero
                    };
                    delete use_filtros.ds_nosso_numero;
                }
            }

            return new Promise((resolve, reject) => {
                this.loadingFiltros = true;
                this.loading = true;
                try {
                    this.tituloService
                        .pesquisaAvancadaTitulos(
                            use_filtros,
                            page,
                            itemsPerPage
                        )
                        .then(
                            response => {
                                this.loadingFiltros = false;
                                this.loading = false;

                                const {
                                    titulos,
                                    total_titulos: total
                                } = response;

                                if (this.selecionarTodos) {
                                    this.todosTitulos = titulos.map(t => ({
                                        ...t
                                    }));
                                } else {
                                    this.titulos = titulos.map(t => ({
                                        ...t
                                    }));
                                }

                                this.totalTitulos = total;
                                resolve();
                            },
                            error => {
                                this.loadingFiltros = false;
                                this.loading = false;
                                this.mostrarSnackbar(
                                    'error',
                                    'Erro ao filtrar títulos'
                                );
                                console.error(
                                    'Erro ao filtrar títulos:',
                                    error
                                );
                                reject(error);
                            }
                        );
                } catch (e) {
                    this.loadingFiltros = false;
                    this.loading = false;
                    this.mostrarSnackbar(
                        'error',
                        'Erro inesperado ao buscar títulos'
                    );
                    console.error('Erro inesperado ao buscar títulos:', e);
                    reject(e);
                }
            });
        },
        setSelecionados(selecionados) {
            this.selecionados = selecionados;
        },
        setTodosSelecionados(selecionarTodos) {
            this.selecionarTodos = selecionarTodos;
            if (selecionarTodos) {
                this.buscarTitulos(this.filtros);
            }
        },
        changeOptionsPage(options) {
            this.options = options;
            this.buscarTitulos(this.filtros);
        },
        abrirModalCessao() {
            if (this.selecionados.length === 0) {
                this.mostrarSnackbar(
                    'warning',
                    'Selecione pelo menos um título'
                );
                return;
            }

            let selectedTitles = this.selecionarTodos
                ? [...this.todosTitulos]
                : [...this.selecionados];

            if (
                this.tituloSearch &&
                Array.isArray(this.tituloSearch) &&
                this.tituloSearch.length > 0
            ) {
                selectedTitles = selectedTitles.map(titulo => {
                    const tituloIdStr =
                        titulo.id_titulo != null
                            ? String(titulo.id_titulo).trim()
                            : '';
                    const tituloNossoNumeroStr =
                        titulo.ds_nosso_numero != null
                            ? String(titulo.ds_nosso_numero).trim()
                            : '';

                    let matchComment = '';

                    for (let i = 0; i < this.tituloSearch.length; i++) {
                        const item = this.tituloSearch[i];
                        const itemIdStr =
                            item.id_titulo != null
                                ? String(item.id_titulo).trim()
                                : '';
                        const itemNossoNumeroStr =
                            item.ds_nosso_numero != null
                                ? String(item.ds_nosso_numero).trim()
                                : '';

                        if (
                            (itemNossoNumeroStr &&
                                itemNossoNumeroStr === tituloNossoNumeroStr) ||
                            (itemIdStr && itemIdStr === tituloIdStr)
                        ) {
                            matchComment = item.comentario || '';
                            break;
                        }
                    }

                    return {
                        ...JSON.parse(JSON.stringify(titulo)),
                        comentario: matchComment
                    };
                });
            }

            this.titulosSelecionados = selectedTitles;
            this.filtros.apresentanteDestino = null;
            this.filtros.cd_carteira = null;
            this.comentarioCessao = '';
            this.showModal = true;
        },
        fecharModal() {
            this.showModal = false;
            this.titulosSelecionados = [];
            this.comentarioCessao = '';
        },
        removerTitulo(titulo) {
            this.titulosSelecionados = this.titulosSelecionados.filter(
                t => t.id_titulo !== titulo.id_titulo
            );
        },
        async confirmarCessao() {
            if (this.titulosSelecionados.length === 0) {
                this.mostrarSnackbar(
                    'warning',
                    'Não há títulos selecionados para transferência'
                );
                return;
            }

            try {
                this.loadingCessao = true;

                const dados = {
                    apresentanteOrigem: this.filtros.apresentanteOrigem,
                    apresentanteDestino: this.filtros.apresentanteDestino,
                    cd_carteira: this.filtros.cd_carteira,
                    titulos: this.titulosSelecionados.map(titulo => {
                        const commentToUse = this.comentarioCessao
                            ? this.comentarioCessao
                            : titulo.comentario || '';

                        return {
                            id_titulo: titulo.id_titulo,
                            ds_nosso_numero: titulo.ds_nosso_numero,
                            comentario: commentToUse
                        };
                    })
                };

                await this.tituloService.transferirCustodiaTitulos(dados);

                this.fecharModal();
                this.mostrarSnackbar(
                    'success',
                    'Cessão de títulos realizada com sucesso'
                );

                await this.buscarTitulos(this.filtros, true);
            } catch (error) {
                this.mostrarSnackbar(
                    'error',
                    'Erro ao realizar cessão de títulos'
                );
                console.error('Erro na cessão de títulos:', error);
            } finally {
                this.loadingCessao = false;
            }
        },
        mostrarSnackbar(cor, mensagem) {
            this.colorSnackbar = cor;
            this.mensagemSnackbar = mensagem;
            this.snackbar = true;
        }
    }
};
</script>

<style scoped>
.ghost-card {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 16px;
}
.v-icon--clearable {
    cursor: pointer;
    opacity: 0.6;
}
.v-icon--clearable:hover {
    opacity: 1;
}
.botao-flutuante {
    z-index: 6;
    margin-bottom: 16px;
    margin-right: 16px;
    transition: opacity 0.3s ease-in-out;
}
</style>
